/// <amd-module name="VSSUI/TeachingBubble" />
export { TeachingBubble } from "./Components/TeachingBubble/TeachingBubble";
export { ITeachingBubbleProps, ICustomTeachingBubbleProps, TeachingBubbleCornerPlacement } from "./Components/TeachingBubble/TeachingBubble.Props";
